export default {
  titles: {
    add: 'New channel configuration',
    editor: 'Edit channel config',
    add1: 'New channel account',
    editor1: 'Edit channel account'
  },

  label: {
    accountId: 'Accounts ID',
    accountId1: 'Accounts email',
    accountName: 'account name',
    accountPassword: 'account password',
    owner: 'Account owner',
    recipientCode: 'channel code',
    recipientId: 'channel ID',
    recipientName: 'equipment number', // 收款渠道名称
    channelName: 'Channel name',
    updateAcct: 'edit acct',
    updateTime: 'edit time',
    accountNumber: 'Receiving account',
    todayTotal: `Today's total payment`,
    yestodayTotal: 'The total received yesterday',
    channelCode: 'channel code',
    channelType: 'Channel type',
    id: 'Primary key ID',
    createAcct: 'Creater account',
    createTime: 'Creation time',
    dayQuota: 'Daily limit',
    monthQuota: 'Monthly quota limit',
    name: 'Channel name',
    serviceType: 'Service type',
    singleMaxLimit: 'Maximum amount transfer',
    singleMinLimit: 'Minimum amount transfer',
    status: 'status',
    action: 'operating',
    h5Logo: 'h5 Logo',
    pcLogo: 'pc Logo',
    supported: 'Supported third',
    refresh: 'Refresh',
    info: 'Channel Info',
    sort: 'Sort'
  },
  rules: {
    id: 'Primary key ID cannot be empty',
    name: 'Channel name cannot be empty',
    channelCode: 'Channel code cannot be empty',
    accountNumber: {
      empty: 'Receiving account cannot be empty',
      type: 'The receiving account must be a number',
      min: 'The length of the receiving account must be greater than or equal to 8',
      max: 'The length of the receiving account must be less than or equal to 32'
    },

    accountId: {
      empty: 'parameters can not empty',
      type: 'parameters can not empty'
    },
    channelName: 'Channel nam cat no be empty',
    channelType: 'Channel type must be selected',
    serviceType: 'Service type must be selected',
    createAcct: 'Create account cannot be empty',
    createTime: 'Creation time must be selected',
    dayQuota: {
      empty: 'The daily limit cannot be empty',
      type: 'The daily limit must be a number',
      match: 'The daily limit must be greater than 0'
    },
    singleMaxLimit: {
      empty: 'The maximum amount transfer cannot be empty',
      type: 'The daily limit must be a number',
      match: 'The maximum amount transfer must be greater than or equal to 50',

      match1:
        'The maximum amount of a single transfer must be greater than the minimum amount of a single transfer'
    },
    singleMinLimit: {
      empty: 'The minimum amount transfer cannot be empty',
      type: 'The daily limit must be a number',
      match: 'The minimum amount transfer must be greater than or equal to 50'
    },
    monthQuota: {
      empty: 'The monthly limit cannot be empty',
      type: 'The daily limit must be a number',
      match: ' monthly limit must be greater than daily limit'
    },
    accountName: {
      empty: 'account name cannot be empty'
    },
    sort: {
      empty: 'sort cannot be empty'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/channel.js